<template>
  <div>
    <h2>Scan Historie</h2><br>
    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>Zeitstempel</th>
        <th>Status</th>
        <th>Nachname</th>
        <th>Vorname</th>
        <th>E-Mail</th>
      </tr>
      </thead>
    </table>
  </div>

</template>

<script>
  /* global $ */

  export default {
    name: 'LionReads',
    data () {
      return {
        // eslint-disable-next-line no-undef
        tableId: 'dTable_' + this.$func.uuid()
      }
    },
    computed: {},
    async mounted () {
      var tableId = this.tableId
      var self = this
      var path = '/lion/read/'

      $(document).ready(function () {
        $('#' + tableId).DataTable({
          dom: 'Bfrtip', // BUTTON/FIND/PROCESSING/TABLE/INFO/PAGING
          ajax: self.$func.addAuth({
            url: path,
            type: 'GET'
          }),
          scrollX: true,
          scrollCollapse: true,
          order: [[0, 'desc']],
          columns: [
            {
              class: 'center',
              data: 'sTimestamp'
            },
            {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                if (data.lStatus == 0) {
                  return 'unbestätigt'
                } else if (data.lStatus == 1) {
                  return 'unbestätigt, erinnert'
                } else if (data.lStatus == 2) {
                  return 'bestätigt'
                }

                return '?'
              }
            },
            {
              class: 'center',
              data: 'oUser.sLastname'
            }, {
              class: 'center',
              data: 'oUser.sFirstname'
            }, {
              class: 'center',
              data: 'oUser.sEmail'
            }
          ],
          buttons: self.$func.addDefaultButtons([])
        })
      })
    }
  }
</script>
<style>

</style>
